import Cookies from "js-cookie";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
const auth = () => {
    const t = Cookies.get("token");
    return t ? { Authorization: `Bearer ${t}` } : {};
};

export async function submitSupportTicket({ subject, message, category, pageUrl }) {
    const res = await fetch(`${API_URL}/api/support`, {
        method: "POST",
        headers: { ...auth(), "Content-Type": "application/json" },
        body: JSON.stringify({ subject, message, category, pageUrl }),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error || "Could not send your message");
    return json;
}

// Opens whatever support channel is active: a third-party live chat if configured
// (Tawk.to / Crisp), otherwise the built-in ticket widget via a window event.
export function openSupport() {
    if (window.Tawk_API && typeof window.Tawk_API.maximize === "function") {
        window.Tawk_API.maximize();
        return;
    }
    if (window.$crisp) {
        window.$crisp.push(["do", "chat:open"]);
        return;
    }
    window.dispatchEvent(new Event("cfai:open-support"));
}
